import { Button, Collapse, Popover } from 'antd';
import React, { Fragment, useState } from 'react';
import {
  EyeOutlined,
  DeleteOutlined,
  DownloadOutlined,
  DownCircleOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ServerAPI } from '../../common/ServerAPI';
import { downloadApplications } from '../../common/Utilities';
import AAUpload from '../../components/AAUpload';
import SelfAAUpload from '../../components/SelfAAUpload';
import { IMAGE_BASE_URL } from '../../common/Constants';
import { ReactComponent as View } from '../../images/view.svg';

const LoanCaseData = ({
  dataRows,
  title,
  icon,
  reloadData,
  pagePermission,
  tabChange,
}) => {
  const navigate = useNavigate();
  const { Panel } = Collapse;
  const [selfAA, setSelfAA] = useState(false);
  const previewForm = async (product_id) => {
    const response = await ServerAPI.previewLoanApplicantion(product_id);
  };
  return (
    <section>
      {dataRows.length > 0 &&
        dataRows.map((dataRow) => {
          const dealerCommPercentage =
            parseFloat(dataRow?.dealer_commission_percentage) || 0;
          const dealerCommAmount =
            parseFloat(dataRow?.dealer_commission_amount) || 0;
          const dealerCommFormatted = `${dealerCommPercentage.toFixed(
            1
          )}% ($${dealerCommAmount.toFixed(0)})`;

          const counterCommPercentage =
            parseFloat(dataRow?.counterData?.agentcommsion).toFixed(1) || '0';
          const counterCommAmount =
            (
              (dataRow?.counterData?.agentcommsion *
                dataRow?.counterData?.loanamount) /
              100
            ).toFixed(0) || '0';
          const counterCommFormatted = `${counterCommPercentage}% ($${Math.round(counterCommAmount)})`;

          const isCountAccept = dataRow.is_counter_offer_accepted;

          return (
            <div className='accordion-section' key={dataRow.key}>
              <div className='loan-app-block'>
                <div className='loan-app-list'>
                  <h2>Interest</h2>
                  <h3
                    className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''
                      }`}
                  >
                    {dataRow?.interest || 'N/A'}%
                  </h3>
                  {dataRow?.counterData && (
                    <h3
                      className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'
                        }`}
                    >
                      {dataRow?.counterData?.interest || 'N/A'}%
                    </h3>
                  )}
                </div>
                <div className='loan-app-list'>
                  <h2>Loan Amt.</h2>
                  <h3
                    className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''
                      }`}
                  >
                    ${dataRow?.loan_amt || 'N/A'}
                  </h3>
                  {dataRow?.counterData && (
                    <h3
                      className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'
                        }`}
                    >
                      $
                      {parseInt(dataRow?.counterData?.loanamount).toFixed(0) ||
                        'N/A'}
                    </h3>
                  )}
                </div>
                <div className='loan-app-list'>
                  <h2>Tenor (mths)</h2>
                  <h3
                    className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''
                      }`}
                  >
                    {dataRow?.tenor || 'N/A'}
                  </h3>
                  {dataRow?.counterData && (
                    <h3
                      className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'
                        }`}
                    >
                      {dataRow?.counterData?.tenure || 'N/A'}
                    </h3>
                  )}
                </div>
                <div className='loan-app-list'>
                  <h2>Dealer Comm.</h2>
                  <h3
                    className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''
                      }`}
                  >
                    {dealerCommFormatted}
                  </h3>
                  {dataRow?.counterData && (
                    <h3
                      className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'
                        }`}
                    >
                      {counterCommFormatted}
                    </h3>
                  )}
                </div>
                <div className='loan-app-list'>
                  <h2>Admin Fee</h2>
                  <h3 className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''}`}>
                    ${Math.round(dataRow?.admin_fee || 0)}
                  </h3>
                  {dataRow?.counterData && (
                    <h3 className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'}`}>
                      ${Math.round(dataRow?.counterData?.admin_fee || 0)}
                    </h3>
                  )}
                </div>
                <div className='loan-app-list'>
                  <h2>Mthly. Installment</h2>
                  <h3 className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''}`}>
                    ${dataRow?.mnthly_installement != null ? Math.ceil(dataRow.mnthly_installement) : 'N/A'}
                  </h3>
                  {dataRow?.counterData && (
                    <h3 className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'}`}>
                      ${dataRow?.counterData?.monthly_installment != null
                        ? Math.ceil(parseFloat(dataRow.counterData.monthly_installment))
                        : 'N/A'}
                    </h3>
                  )}
                </div>

                <div className='loan-app-list'>
                  <h2>Last Installment</h2>
                  <h3 className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''}`}>
                    ${dataRow?.last_installment != null ? Math.ceil(dataRow.last_installment) : 'N/A'}
                  </h3>
                  {dataRow?.counterData && (
                    <h3 className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'}`}>
                      ${dataRow?.counterData?.last_installment != null
                        ? Math.ceil(parseFloat(dataRow.counterData.last_installment))
                        : 'N/A'}
                    </h3>
                  )}
                </div>

              </div>
              <div className='loan-footer-block'>
                <div className='loan-footer-list'>
                  <Button
                    className='sav_btn'
                    onClick={() => {
                      navigate('/view-application', {
                        state: {
                          productId: dataRow?.application_product,
                        },
                      });
                    }}
                  >
                    <span>
                      <View />
                    </span>
                    View Application Form
                  </Button>
                  {pagePermission?.update_permission == 0 ||
                    dataRow?.disbursementinfo ? (
                    <Fragment>
                      <Button
                        className='sav_btn'
                        onClick={() => {
                          tabChange(6);
                        }}
                      >
                        <span>
                          <View />
                        </span>
                        View Disbursement
                      </Button>
                    </Fragment>
                  ) : null}
                  {dataRow.status != null &&
                    dataRow.status.instant_aa == true &&
                    dataRow.status?.aa_files?.length > 0 &&
                    dataRow?.status?.aa_files.map((file, idx) => {
                      return (
                        <Fragment>
                          <Button
                            className='sav_btn'
                            onClick={() => {
                              window.open(
                                IMAGE_BASE_URL + '/' + file.value,
                                '_blank'
                              );
                            }}
                          >
                            <span>
                              <View />
                            </span>
                            View AA
                          </Button>
                        </Fragment>
                      );
                    })}
                </div>
                <div className='lnCol11 acc-footer-action'>
                  <div className='flex flex-wrap gap-4 max-sm:w-full'>
                    {dataRow.status != null &&
                      dataRow.status.instant_aa == true &&
                      dataRow.disbursementinfo === null &&
                      pagePermission?.update_permission == 1 && (
                        <Fragment>
                          {dataRow.status?.aa_files?.length > 0 && (
                            <div
                              className='text-[#FFF] max-sm:w-full p-[5px_10px] font-[600] bg-[#1677ff] border border-[#1677ff] min-[768px]:text-[13px] max-[768px]:text-[12px] text-center p-[0.5px] rounded cursor-pointer  w-[110px]'
                              onClick={() => {
                                let statusData = {
                                  loan_application: dataRow?.agentupdatestatus.loan_application,
                                  application_product: dataRow?.agentupdatestatus.application_product,
                                  product: dataRow?.agentupdatestatus.application_product,
                                  interest: dataRow?.agentupdatestatus.interest,
                                  agentcommision: dataRow?.agentupdatestatus.agentcommision,
                                  description: dataRow?.agentupdatestatus.description,
                                  is_counter_offered: dataRow?.agentupdatestatus.is_counter_offered == true ? 1 : 0,
                                  is_approved: dataRow?.agentupdatestatus.is_approved == true ? 1 : 0,
                                  is_rejected: dataRow?.agentupdatestatus.is_rejected == true ? 1 : 0,
                                  instant_aa: 1,
                                  counter_value: {
                                    tenure: dataRow.tenure,
                                    parfvalue: dataRow.parfvalue,
                                    loanamount: dataRow.loanamount,
                                    monthly_installment: dataRow.monthly_installment,
                                    interest: dataRow.interest,
                                    agentcommsion: dataRow.dealer_commission_percentage,
                                    admin_fee: dataRow.admin_fee,
                                    remarks: dataRow.remarks,
                                    last_installment: dataRow.last_installment,
                                    terms_and_conditions: dataRow.terms_and_conditions,
                                  },
                                };
                                localStorage.setItem(
                                  'statusData',
                                  JSON.stringify(statusData)
                                );
                                setSelfAA(true);
                              }}
                            >
                              Replace AA
                            </div>
                          )}
                        </Fragment>
                      )}

                    {dataRow.type != 'In-House' &&
                      dataRow.status != null &&
                      dataRow.status.instant_aa == false &&
                      null}

                    {dataRow.status != null &&
                      dataRow.status.instant_aa == false &&
                      dataRow.type == 'In-House' &&
                      (dataRow.status.is_counter_offered == true ||
                        dataRow.status.is_approved == true) &&
                      pagePermission?.update_permission == 1 && (
                        <Fragment>
                          <Button
                            className='text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[13px] max-[768px]:text-[12px] bg-white  w-[110px]'
                            onClick={() => {
                              let statusData = {
                                loan_application:
                                  dataRow?.agentupdatestatus.loan_application,
                                application_product:
                                  dataRow?.agentupdatestatus
                                    .application_product,
                                product:
                                  dataRow?.agentupdatestatus
                                    .application_product,
                                interest: dataRow?.agentupdatestatus.interest,
                                agentcommision:
                                  dataRow?.agentupdatestatus.agentcommision,
                                description:
                                  dataRow?.agentupdatestatus.description,
                                is_counter_offered:
                                  dataRow?.agentupdatestatus
                                    .is_counter_offered == true
                                    ? 1
                                    : 0,
                                is_approved:
                                  dataRow?.agentupdatestatus.is_approved == true
                                    ? 1
                                    : 0,
                                is_rejected:
                                  dataRow?.agentupdatestatus.is_rejected == true
                                    ? 1
                                    : 0,
                                instant_aa: 1,
                                counter_value: {
                                  tenure: dataRow.tenure,
                                  parfvalue: dataRow.parfvalue,
                                  loanamount: dataRow.loanamount,
                                  monthly_installment:
                                    dataRow.monthly_installment,
                                  interest: dataRow.interest,
                                  agentcommsion:
                                    dataRow.dealer_commission_percentage,
                                  admin_fee: dataRow.admin_fee,
                                  remarks:
                                    dataRow.remarks,
                                  last_installment:
                                    dataRow.monthly_installment,
                                  terms_and_conditions:
                                    dataRow.terms_and_conditions,
                                },
                              };
                              localStorage.setItem(
                                'statusData',
                                JSON.stringify(statusData)
                              );
                              setSelfAA(true);
                            }}
                          >
                            Upload AA
                          </Button>
                          <br />
                          <p className='text-center mt-2 mb-2'>( or )</p>
                          <Button
                            className='text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[13px] max-[768px]:text-[12px] bg-white w-[110px]'
                            onClick={() => {
                              let statusData = {
                                loan_application:
                                  dataRow?.agentupdatestatus.loan_application,
                                application_product:
                                  dataRow?.agentupdatestatus
                                    .application_product,
                                product:
                                  dataRow?.agentupdatestatus
                                    .application_product,
                                interest: dataRow?.agentupdatestatus.interest,
                                agentcommision:
                                  dataRow?.agentupdatestatus.agentcommision,
                                description:
                                  dataRow?.agentupdatestatus.description,
                                is_counter_offered:
                                  dataRow?.agentupdatestatus
                                    .is_counter_offered == true
                                    ? 1
                                    : 0,
                                is_approved:
                                  dataRow?.agentupdatestatus.is_approved == true
                                    ? 1
                                    : 0,
                                is_rejected:
                                  dataRow?.agentupdatestatus.is_rejected == true
                                    ? 1
                                    : 0,
                                instant_aa: 1,
                                counter_value: {
                                  tenure: dataRow.tenure,
                                  parfvalue: dataRow.parfvalue,
                                  loanamount: dataRow.loanamount,
                                  monthly_installment:
                                    dataRow.monthly_installment,
                                  interest: dataRow.interest,
                                  agentcommsion:
                                    dataRow.dealer_commission_percentage,
                                  admin_fee: dataRow.admin_fee,
                                  remarks: dataRow.remarks,
                                  last_installment: dataRow.last_installment,
                                  terms_and_conditions: dataRow.terms_and_conditions,
                                },
                              };
                              navigate('/preview-aa', {
                                state: statusData,
                              });
                            }}
                          >
                            Issue AA
                          </Button>
                        </Fragment>
                      )}
                    {dataRow.type == 'In-House' &&
                      dataRow.status?.is_rejected == 1 &&
                      null}
                    {dataRow.status == null && null}
                    <SelfAAUpload
                      close={() => {
                        setSelfAA(false);
                      }}
                      open={selfAA}
                      reloadData={reloadData}
                    />
                    <Button
                      onClick={() => {
                        downloadApplications();
                      }}
                      className='text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex items-center'
                    >
                      <DownloadOutlined className='mr-2' />
                      <span>Download Alls</span>
                    </Button>
                  </div>
                  <div>
                    {pagePermission?.update_permission == 0 ||
                      dataRow?.disbursementinfo ? null : (
                      <div
                        className={`${pagePermission?.update_permission == 0
                          ? 'cursor-not-allowed'
                          : dataRow.disbursementinfo && 'cursor-not-allowed'
                          }`}
                      >
                        <div
                          className={`flex gap-[10px] max-sm:w-full max-sm:justify-between w-[160px] max-w-full items-center ${pagePermission?.update_permission == 0
                            ? 'pointer-events-none'
                            : dataRow.disbursementinfo &&
                            'pointer-events-none'
                            }`}
                        >
                          <h4 className='text-xs font-medium'>Actions</h4>
                          {pagePermission?.update_permission == 1 && (
                            <div className='flex items-center gap-[10px]'>
                              <Popover content='Approve'>
                                <span
                                  className='cursor-pointer'
                                  onClick={() => {
                                    navigate('/case-detail-status', {
                                      state: {
                                        loanData: dataRow,
                                        title: title,
                                        icon: icon,
                                        optLabel:
                                          dataRow?.type === 'In-House'
                                            ? 'approve_instant'
                                            : 'approve_instant_bank',
                                      },
                                    });
                                  }}
                                >
                                  <img
                                    src='/images/act_appr.png'
                                    className='h-[33px] w-[33px] object-contain mt-1'
                                  />
                                </span>
                              </Popover>
                              <Popover content='Counter Offer'>
                                <span
                                  className='cursor-pointer'
                                  onClick={() => {
                                    // localStorage.setItem("counter-offer", value);
                                    navigate('/case-detail-status', {
                                      state: {
                                        loanData: dataRow,
                                        title: title,
                                        icon: icon,
                                        optLabel: 'counter_instant',
                                      },
                                    });
                                  }}
                                >
                                  <img
                                    src='/images/act_coun.png'
                                    className='h-[35px] w-[35px] object-contain relative top-[2px]'
                                  />
                                </span>
                              </Popover>
                              <Popover content='Reject'>
                                <span
                                  className='cursor-pointer'
                                  onClick={() => {
                                    navigate('/case-detail-status', {
                                      state: {
                                        loanData: dataRow,
                                        title: title,
                                        icon: icon,
                                        optLabel: 'reject',
                                      },
                                    });
                                  }}
                                >
                                  <img
                                    src='/images/act_rej.png'
                                    className='h-[33px] w-[33px] object-contain mt-1'
                                  />
                                </span>
                              </Popover>
                            </div>)}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {dataRow.furnish_guarantors != undefined &&
                dataRow.furnish_guarantors.length > 0 && (
                  <div>
                    <Collapse
                      defaultActiveKey={'1'}
                      bordered={false}
                      className='custom-collapse'
                      expandIconPosition={'end'}
                    >
                      <Panel
                        header='Additional Guarantor(s)'
                        key='1'
                        showArrow={true}
                        className='custom-panel header'
                      >
                        {dataRow.furnish_guarantors.map((guarantor, idx) => {
                          return (
                            <p className='mx-3 text-[#00AE11] mb-[12px]'>
                              Guarantor ({idx + 1}):{' '}
                              {guarantor?.guarantor_relation +
                                ' - ' +
                                'Min Income $ ' +
                                parseFloat(guarantor.guarantor_income).toFixed(
                                  0
                                )}
                            </p>
                          );
                        })}
                      </Panel>
                    </Collapse>
                  </div>
                )}
            </div>
          );
        })}
    </section>
  );
};

export default LoanCaseData;
